import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import CastingCommon from '@utils/casting-common';

import Card          from '@common/influencer/_card';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class InfluencerProfile extends React.Component {
  /*
   * 下書き作成
   */
  create() {
    let detail = this.props.detail;
    let insta_user_id = detail.influencer.insta_user_id;
    
    let chk = confirm('インフルエンサーの代わりに下書きを作成します。よろしいですか？\n（通常のフローとは異なる手順になりますご注意ください）');
    if( chk == false ) return;
    
    Utils.request.bind(this)('/api/draft/create', { project_id: this.props.data.project.id, insta_user_id: insta_user_id },
      function(res){
        this.props.refresh_ev.bind(this)(insta_user_id, false);
      }.bind(this),
      function(res){
        
        Utils.request.bind(this)('/api/draft/create', { project_id: this.props.data.project.id, insta_user_id: insta_user_id, compulsion: true },
          function(res){
            this.props.refresh_ev.bind(this)(insta_user_id, false);
          }.bind(this),
        );
        
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  /*
   * 下書き作成
   */
  alert_link(url) {
    let chk = confirm('インフルエンサーが下書き作成中です。作成途中のデータを表示しますか？\n（通常のフローとは異なる手順になりますご注意ください）');
    if( chk == false ) return;
    
    //location.href = url;
    window.open(url, '_blank');
  }
  // -------------------------------------------------------
  
  render() {
    let detail = this.props.detail;
    let draft = detail.draft;
    
    let progress_status = CastingCommon.getProgressStatus(detail.workflow.progress, detail.workflow_groups.list, detail.workflow.is_ng);
    
    // 同じグループのメンバー
    let members = [];
    try { members = detail.workflow_groups.items_base[detail.workflow.progress]; } catch(e){}
    if( members == undefined ) members = [];
    
    // 下書き完了フラグ
    let is_draft_complete = false;
    try { is_draft_complete = detail.workflow_status.is_draft_complete; } catch(e) {}
    
    return (
      <div className="influencer-profile-box">
        <div className="influencer-profile">
          <div className={'color_'+ progress_status.color}>
            <Card data={detail.influencer} list={members} option={['is_not_info','is_not_import_action']} profiling_button={true} />
          </div>
          
          <div className="user-name">
            <h5>@{detail.influencer.insta_id}</h5>
            <h3>{detail.influencer.full_name}</h3>
          </div>
        </div>
        
        <div className="profile-actions">
          { (Object.keys(draft).length > 0 && draft.is_submission == 1) &&
            <a className="button" href={'/draft/'+ draft.unique_id} target="_blank">
              下書き確認
              <i className="material-icons">arrow_forward</i>
            </a>
          }
          
          { (Object.keys(draft).length > 0 && draft.is_submission == 0) &&
            <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>下書き中の内容を確認する</Tooltip>}>
              <div className="button active" onClick={this.alert_link.bind(this, '/draft/'+ draft.unique_id)}>
                下書き確認
                <i className="material-icons">arrow_forward</i>
              </div>
            </OverlayTrigger>
          }
          
          { (Object.keys(draft).length == 0) &&
            <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>インフルエンサーの代わりに下書きを作成する</Tooltip>}>
              <div className="button off-active" onClick={this.create.bind(this)}>
                下書き作成
                <i className="material-icons">arrow_forward</i>
              </div>
            </OverlayTrigger>
          }
          
          { (is_draft_complete === 1)
            ? <div className="button active" onClick={this.props.data.event.showReportCandidateModal.bind(this, this.props.data.project.id, detail.influencer.insta_user_id, null)}>
                投稿・インサイト
                <i className="material-icons">arrow_forward</i>
              </div>
            : <div className="button off-active" onClick={this.props.data.event.showReportCandidateModal.bind(this, this.props.data.project.id, detail.influencer.insta_user_id, null)}>
                投稿・インサイト
                <i className="material-icons">arrow_forward</i>
              </div>
          }
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InfluencerProfile;